<!--child.vue-->
<template>
  <div class="tips_wrap">
    <el-dialog
      :close-on-click-modal="false"
      title="远程开机"
      :visible.sync="dialogFormVisible"
      @close="closeDialog"
    >
      <div style="display: flex">
        <div>
          <el-input
            clearable
            style="width: 200px; margin-right: 10px"
            placeholder="请输入电脑左下角机器码查询"
            v-model="jqm"
          />
        </div>

        <div class="item">
          <el-button type="primary" @click="init()">查询</el-button>
        </div>
        <div class="item">
          <el-button type="primary" @click="clear">清空</el-button>
        </div>

      </div>
      <el-table :data="gridData" style="width: 100%" height="400px">
        <el-table-column label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          property="jqm"
          label="机器码"
          width="150"
        ></el-table-column>
        <el-table-column
          property="createTime"
          label="开机时间"
          width="150"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="takeCode(scope.row)" size="small"
              >开机</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("我是子组件");
  },

  data() {
    return {
      gridData: [],
      jqm: "",
      loading: false,
      ruleForm: {
        jqm: "",
        endTime: "",
      },
      dialogFormVisible: this.dialogShow,
    };
  },
  created() {
    this.init();
  },
  watch: {
    dialogShow(val) {
      this.dialogFormVisible = val;
    },
  },
  methods: {
    takeCode(item) {
      var that=this
      this.$axios
        .get("/api2/code/takeCode/" + item.jqm, {})
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.jqm = "";
            that.init();
          } else {
            that.$message.error(response.mes);
          }
          that.loading = false;
        });
    },
    clear(){
      this.jqm=""
      this.init()
    },
    init() {
      var that = this;
      that.loading = true;
      this.$axios
        .post("/api2/code/findMyCode/", {
          userId: that.$store.state.user.user.id,
          jqm: that.jqm,
        })
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            console.log(response.data.data);
            that.gridData = response.data.data;
          } else {
            that.$message.error(response.mes);
          }
          that.loading = false;
        });
    },
    submitForm() {
      var that = this;

      this.$axios
        .post("/api2/user/registerByAdmin", that.ruleForm)
        .then(function (response) {
          console.log(response.data);
          if (response.data.code == 200) {
            that.$message({
              type: "success",
              message: "操作成功",
            });
            that.$emit("pushdata");
            that.closeDialog();
          } else {
            that.$message.error(response.data.mes);
          }
        });
    },

    closeDialog() {
      this.$emit("modelChange", false);
    },
  },
};
</script>

